import i18next from "i18next";
import { IoChatbubblesOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

import { OrderActions, SupportButton } from "./style";

// Кнопка «Поддержка» в списке заказов (рядом с «Возврат»): новая заявка с уже выбранным заказом.
// Клик не открывает страницу заказа.
const OrderSupportLink = ({ orderId, fullWidth = false }) => {
  const { t } = i18next;
  const navigate = useNavigate();

  if (!orderId) return null;

  const handleClick = e => {
    e.stopPropagation();
    navigate(`/support?order_id=${encodeURIComponent(orderId)}`);
  };

  return (
    <SupportButton
      type="button"
      onClick={handleClick}
      title={t("support_write")}
      style={fullWidth ? { width: "100%" } : undefined}
    >
      <IoChatbubblesOutline />
      {t("support_write_short")}
    </SupportButton>
  );
};

export { OrderActions };

export default OrderSupportLink;
